jQuery(function($){
    var $acordeon = $('.js-acc');

    $acordeon.each(function(){
       var $this = $(this);
        var $acordeon__btn = $this.find('.js-acc__btn');
        var $acordeon__close = $this.find('.js-acc__close');
        var $acordeon__open = $this.find('.js-acc__open');

        $acordeon__btn.on('click', function(){
            $acordeon__close.slideUp();
            $acordeon__open.slideDown();
        });
    });
});
